<app-kpi-details-dialog [title]="title" [subtitle]="subtitle">
  <div class="compliance-layout">
    <div class="month-calendar" role="grid" [attr.aria-label]="calendar_aria_label">
      <div class="weekday-row" role="row">
        @for (label of weekday_labels; track label) {
          <div class="weekday" role="columnheader">{{ label }}</div>
        }
      </div>

      <div class="calendar-grid">
        @for (cell of calendar_cells; track cell.id) {
          @if (cell.evaluation; as day) {
            @if (cell.is_day_off) {
              <div
                class="calendar-cell is-day-off"
                [class.is-vacation]="cell.is_vacation"
                [class.is-holiday]="cell.is_holiday"
                [class.is-absence]="cell.is_absence"
                role="button"
                tabindex="0"
                [class.is-selected]="cell.date === selected_date()"
                [class.is-today]="cell.is_today"
                [attr.aria-label]="cell.aria_label"
                [attr.aria-pressed]="cell.date === selected_date()"
                matTooltipPosition="above"
                matTooltipShowDelay="200"
                matTooltipClass="kpi-tooltip"
                (click)="selectDay(day.date)"
              >
                <div class="calendar-cell-content">
                  <span class="day-number">{{ cell.day_number }}</span>
                  <span class="day-off-emoji" aria-hidden="true">{{ cell.day_off_emoji }}</span>
                </div>
              </div>
            } @else {
              <div
                class="calendar-cell is-evaluable"
                role="button"
                tabindex="0"
                [class.is-ok]="day.is_day_ok"
                [class.is-not-ok]="!day.is_day_ok"
                [class.is-selected]="cell.date === selected_date()"
                [class.is-today]="cell.is_today"
                [attr.aria-label]="cell.aria_label"
                [attr.aria-pressed]="cell.date === selected_date()"
                (click)="selectDay(day.date)"
              >
                <div class="calendar-cell-content">
                  <span class="day-number">{{ cell.day_number }}</span>
                  <span class="day-icons">
                    <span class="day-status-pill is-schedule" [class.is-ok]="day.is_schedule_ok" [class.is-not-ok]="!day.is_schedule_ok">
                      <span class="day-status-emoji" aria-hidden="true">🕑</span>
                      <span class="day-status-mark">{{ cell.schedule_mark }}</span>
                    </span>
                    <span class="day-status-pill is-remote" [class.is-ok]="day.is_remote_ok" [class.is-not-ok]="!day.is_remote_ok">
                      <span class="day-status-emoji" aria-hidden="true">🏠</span>
                      <span class="day-status-mark">{{ cell.remote_mark }}</span>
                    </span>
                  </span>
                </div>
              </div>
            }
          } @else if (cell.day_number !== null) {
            <div class="calendar-cell is-muted" [class.is-today]="cell.is_today" [attr.aria-label]="cell.aria_label">
              <div class="calendar-cell-content">
                <span class="day-number">{{ cell.day_number }}</span>
              </div>
            </div>
          } @else {
            <div class="calendar-cell is-empty" aria-hidden="true"></div>
          }
        }
      </div>
    </div>

    <div class="side-panel">
      <div class="month-stats-panel">
        <div class="month-stats">
          <div class="month-stat-chip">
            <span class="month-stat-label">Desfase medio</span>
            <span class="month-stat-value">
              {{ data.average_offset_minutes | number: '1.0-0' }}
              <span class="month-stat-unit">min</span>
            </span>
          </div>

          <div class="month-stat-chip">
            <span class="month-stat-label">Racha actual</span>
            <span class="month-stat-value">
              @if (data.streak_emoji) {
                <span class="streak-icon">{{ data.streak_emoji }}</span>
              }
              {{ data.current_streak }}
              <span class="month-stat-unit">{{ data.streak_unit }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="day-panel">
        @if (selected_day(); as day) {
          @if (day.is_day_off) {
            <div class="day-detail is-day-off">
              <h5 class="day-detail-title">{{ day.date | date: 'EEEE d MMMM' : 'Europe/Madrid' : 'es-ES' }}</h5>
              <div class="day-off-detail">
                <span class="day-off-detail-emoji" aria-hidden="true">{{ day.day_off_emoji }}</span>
                <p class="day-off-detail-text">{{ day.day_off_label }}</p>
              </div>
            </div>
          } @else {
            <div class="day-detail">
              <div class="day-detail-header">
                <h5 class="day-detail-title">{{ day.date | date: 'EEEE d MMMM' : 'Europe/Madrid' : 'es-ES' }}</h5>
                @if (day.is_day_ok) {
                  <span class="day-status-badge is-ok">Correcto</span>
                } @else {
                  <span class="day-status-badge is-not-ok">A mejorar</span>
                }
              </div>

              <div class="compliance-rows">
                <div class="compliance-row" [class.is-ok]="day.is_schedule_ok" [class.is-not-ok]="!day.is_schedule_ok">
                  <div class="compliance-row-header">
                    <span class="compliance-row-icon" aria-hidden="true">🕑</span>
                    <span class="compliance-row-title">Horario</span>
                    <span class="compliance-row-mark">{{ day.schedule_mark }}</span>
                  </div>
                  <p class="compliance-row-text">{{ day.schedule_explanation }}</p>
                </div>

                <div class="compliance-row" [class.is-ok]="day.is_remote_ok" [class.is-not-ok]="!day.is_remote_ok">
                  <div class="compliance-row-header">
                    <span class="compliance-row-icon" aria-hidden="true">🏠</span>
                    <span class="compliance-row-title">Teletrabajo</span>
                    <span class="compliance-row-mark">{{ day.remote_mark }}</span>
                  </div>
                  <p class="compliance-row-text">{{ day.remote_explanation }}</p>
                </div>
              </div>

              @if (day.has_accepted_extra_hours) {
                <div class="extra-hours-callout">
                  <span class="extra-hours-callout-icon" aria-hidden="true">ℹ️</span>
                  <p class="extra-hours-callout-text">El día cuenta como correcto porque hay horas extra</p>
                </div>
              }

              @if (day.partial_absence_note) {
                <div class="extra-hours-callout">
                  <span class="extra-hours-callout-icon" aria-hidden="true">ℹ️</span>
                  <p class="extra-hours-callout-text">{{ day.partial_absence_note }}</p>
                </div>
              }
            </div>
          }
        } @else {
          <p class="day-detail-empty">Selecciona un día del calendario para ver el detalle.</p>
        }
      </div>
    </div>
  </div>
</app-kpi-details-dialog>
